import { useId, useState } from 'react';
function Accordion({ title, defaultOpen = false, children }) {
  const [open, setOpen] = useState(defaultOpen);
  const panelId = useId();
  const buttonId = useId();
  return (
    <div className={['tcf-accordion', open ? 'tcf-accordion--open' : ''].join(' ').trim()}>
      <h3 className="tcf-accordion-heading">
        <button
          type="button"
          id={buttonId}
          className="tcf-accordion-trigger"
          aria-expanded={open}
          aria-controls={panelId}
          onClick={() => setOpen((o) => !o)}
        >
          <span className="tcf-eyebrow">{title}</span>
          <span className="tcf-accordion-icon" aria-hidden="true">
            {open ? '\u2013' : '+'}
          </span>
        </button>
      </h3>
      <div id={panelId} role="region" aria-labelledby={buttonId} className="tcf-accordion-panel" hidden={!open}>
        <div className="tcf-accordion-body">{children}</div>
      </div>
    </div>
  );
}
export { Accordion };
